import React, { useMemo } from 'react'
import moment from 'moment'
import config from 'constants/config'
import useToggle from 'hooks/useToggle'
import TextLink from 'LuxKit/TextLink'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import USPModal from './USPModal'

interface Props {
  offer: App.Offer
}

function FlashHotelWePriceMatch(props: Props) {
  const { offer } = props

  const [open, , openModal, closeModal] = useToggle()
  const bookBy = useMemo(() => moment(offer.bookByDate), [offer.bookByDate])
  const travelUntil = useMemo(() => moment(offer.travelToDate), [offer.travelToDate])

  const shouldShowPriceMatch = !!(
    !offer.bundledWithFlightsOnly &&
    config.bestPriceGuarantee &&
    !offer.disableBestPriceGuarantee
  )

  return shouldShowPriceMatch && (<>
    <TextLink
      colour="highlight-secondary"
      size="small"
      underline={false}
      startIcon={<LineTagAltIcon />}
      onClick={openModal}
    >
      We price match
    </TextLink>
    <USPModal open={open} onClose={closeModal} modalType="bestPrice" bookBy={bookBy} travelUntil={travelUntil} />
  </>)
}

export default FlashHotelWePriceMatch
